import UploadsAudioAiStudy from "./UploadsAudioAiStudy";

export default UploadsAudioAiStudy;